export default {
  label: {
    title: 'Filtros globales',
    description: 'Aquí define las reglas de filtrado para todo el dashboard.',
    notClassified: 'No Clasificados',
    filters: {
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Tags',
      status: 'Estado',
      repliers: 'Respondedores',
      contract: 'Contrato',
      bot: 'Bot',
      channels: 'Canales',
      operators: 'Agentes',
      teams: 'Colas',
    },
    button: {
      cancelButton: 'Cancelar',
      confirmButton: 'Aplicar',
      clearButton: 'Limpiar todo',
      primaryButton: 'Confirmar',
    },
    listening: {
      subtitle: 'Publicaciones',
      session: {
        what: 'Qué',
        when: 'Cuándo',
        where: 'Dónde',
        who: 'Quién',
      },
    },
    sac: {
      subtitle: 'Métricas propietarias y Smart Care',
    },
    blip: {
      subtitle: 'Blip',
    },
    desk: {
      subtitle: 'Atención humana',
    },
  },
};
